export const DOCUMENT_PREVIEW_DRAG_HANDLE_CLASS = 'document-preview-dialog-drag-handle';

export const DOCUMENT_PREVIEW_DEFAULT_HEIGHT = 540;
export const DOCUMENT_PREVIEW_DEFAULT_WIDTH = 720;
export const DOCUMENT_PREVIEW_DEFAULT_TOP = 80;
export const DOCUMENT_PREVIEW_MIN_HEIGHT = 240;
export const DOCUMENT_PREVIEW_MIN_WIDTH = 280;
export const DOCUMENT_PREVIEW_VIEWPORT_GUTTER = 16;

export const DOCUMENT_PREVIEW_RESIZE_HANDLES = [
  'n',
  's',
  'e',
  'w',
  'ne',
  'nw',
  'se',
  'sw',
] as const;
